import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import GlobalStyles from '@mui/material/GlobalStyles';
import {
  createTheme,
  ThemeProvider,
} from '@mui/material/styles';
import {
  theme as themeDefault,
  hyphenation,
} from './index';
import colorsDefault from './colors';

export const executiveColors = {
  ...colorsDefault,
  primary: colorsDefault.black,
  secondary: colorsDefault.black,
  primaryText: colorsDefault.black,
} as const;

export const theme = createTheme({
  ...themeDefault,
  colors: {
    ...themeDefault.colors,
    ...executiveColors,
  },
  palette: {
    primary: {
      main: executiveColors.primary,
    },
    secondary: {
      main: executiveColors.secondary,
    },
  },
  typography: {
    ...themeDefault.typography,
    overline: {
      ...themeDefault.typography.overline,
      color: executiveColors.primary,
    },
  },
});

const globalStyles = (
  <GlobalStyles styles={{
    ':root': {
      ...hyphenation,
      overflowY: 'scroll',
    },
  }}
  />
);

export const themePropertyTypes = {
  children: PropTypes.node,
};

export type ThemeProperties = InferProps<typeof themePropertyTypes>;

export default function ThemeWrapper({ children }: ThemeProperties) {
  return (
    <ThemeProvider theme={theme}>
      {globalStyles}
      {children}
    </ThemeProvider>
  );
}

ThemeWrapper.propTypes = themePropertyTypes;
